import { Host } from '../../index'

const AdminSysteminfo = `${Host}agency/index/system_info`
const AdminLoginConfig = `${Host}agency/publics/login_config`
const AdminPublicsLogin = `${Host}agency/publics/login`
const AdminPublicsLogout = `${Host}agency/publics/logout`
const AdminPublicsRefresh = `${Host}agency/publics/refresh`
const AdminPublicsCaptcha = `${Host}agency/publics/captcha`

const AdminMenus = `${Host}agency/menu/menus`

const AdminAttachmentList = `${Host}agency/attachment/index`
const AdminAttachmentUpload = `${Host}agency/attachment/upload`
const AdminAttachmentDirList = `${Host}agency/attachment/list_dir`
const AdminAttachmentDirAdd = `${Host}agency/attachment/add_dir`
const AdminAttachmentDirEdit = `${Host}agency/attachment/edit_dir`
const AdminAttachmentDirDel = `${Host}agency/attachment/del_dir`

const AdminAjaxSelectList = `${Host}agency/ajax/get_select_list`
const AdminAjaxLevelData = `${Host}agency/ajax/get_level_data`

export default {
    AdminSysteminfo,

    AdminLoginConfig,

    AdminMenus,

    AdminPublicsLogin,
    AdminPublicsLogout,
    AdminPublicsRefresh,
    AdminPublicsCaptcha,

    AdminAttachmentDirList,
    AdminAttachmentDirAdd,
    AdminAttachmentDirEdit,
    AdminAttachmentDirDel,
    AdminAttachmentList,
    AdminAttachmentUpload,

    AdminAjaxSelectList,
    AdminAjaxLevelData
}
